import { PackagingComponentDto } from './packaging-component-dto';

export class PackagingAidDto extends PackagingComponentDto {
    isRigidComponent = false;
}
